
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sindromedeseptiembre",
      function () {
        return require("private-next-pages/sindromedeseptiembre.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sindromedeseptiembre"])
      });
    }
  